/**
 * BrandLogo — uses the same asset as favicons/PWA: /blissnet-master-1024.png (public → dist root).
 */

const BRAND_ICON_SRC = "/blissnet-master-1024.png";

interface BrandLogoProps {
  size?: number;
  className?: string;
  alt?: string;
}

export function BrandLogo({ 
  size = 48, 
  className = "", 
  alt = "BlissNet" 
}: BrandLogoProps) {
  return (
    <img
      src={BRAND_ICON_SRC}
      width={size}
      height={size}
      alt={alt}
      className={`block shrink-0 object-contain object-center m-0 ${className}`.trim()}
      loading="lazy"
      decoding="async"
    />
  );
}

